import { SALES_TYPE } from '../../../common/constant/page-constant'

const SaleStatusTabs = ({ filterOptions, updateFilterOptions }) => {
  const handleTabClick = (status) => {
    updateFilterOptions({ status })
  }

  return (
    <ul className="tabs dFlex">
      <li
        className={`tabItem ${
          filterOptions?.status === SALES_TYPE.COMPLETED ? 'active' : ''
        }`}
        onClick={() => handleTabClick(SALES_TYPE.COMPLETED)}
      >
        Confirmed
      </li>
      <li
        className={`tabItem ${
          filterOptions?.status === `${SALES_TYPE.DRAFT_HOLD_STATUS_LIST}`
            ? 'active'
            : ''
        }`}
        onClick={() => handleTabClick(`${SALES_TYPE.DRAFT_HOLD_STATUS_LIST}`)}
      >
        Draft & Hold
      </li>
      <li
        className={`tabItem ${
          filterOptions?.status === SALES_TYPE.CANCELLED ? 'active' : ''
        }`}
        onClick={() => handleTabClick(SALES_TYPE.CANCELLED)}
      >
        Cancelled
      </li>
    </ul>
  )
}

export default SaleStatusTabs
